module.exports = __webpack_public_path__ + "img/bannerLabel3Orange.b03d641b.png";